import React, { useEffect } from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import HubbleRefereeContainer from "@jumbo/Dashboards/HubbleContainer/HubbleRefereeContainer";
import { setSelectedJudge } from "redux/actions/Hubble";
import HubbleRequests from "services/hubble";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.hubbleReferee"} />, isActive: true },
];

const HubbleReferee = () => {
  const dispatch = useDispatch();
  const { selectedJudge, hubbleJudges } = useSelector(({ hubble }) => hubble);

  useEffect(() => {
    dispatch(HubbleRequests.getJudgeList());
  }, []);

  return (
    <PageContainer
      heading={<IntlMessages id="pages.hubbleReferee" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={"10px"}
          >
            <div>
              <IntlMessages id="pages.hubbleReferee.description" />
            </div>
            <FormControl variant="outlined" style={{ width: "250px" }}>
              <InputLabel id="demo-simple-select-outlined-label">
                داور 
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selectedJudge}
                onChange={(e) => dispatch(setSelectedJudge(e.target.value))}
                label="judge"
              >
                {hubbleJudges.map((item) => (
                  <MenuItem value={item.owner._id}>
                    {item.owner.fullName}
                  </MenuItem>
                ))}
                <MenuItem value={""}>همه موارد</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Divider />
          <div style={{ marginTop: 24 }}>
            <HubbleRefereeContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default HubbleReferee;
